import BigNumber from "bignumber.js";

export const BASE18 = BigNumber("1000000000000000000");
export const BASE8 = BigNumber("100000000");
export const BASE9 = BigNumber("1000000000");
export const RENT_CONTRACT_TIME_BASE = parseInt(process.env.REACT_APP_RENT_CONTRACT_TIME_BASE);
export const MIN_PRICE_PER_HOUR_FOR_RENT = process.env.REACT_APP_MIN_PRICE_PER_HOUR_FOR_RENT || "50";
export const BNB_MIN_PRICE_PER_HOUR_FOR_RENT = process.env.REACT_APP_BNB_MIN_PRICE_PER_HOUR_FOR_RENT || "0.002";
export const MIN_PRICE_FOR_SALE = process.env.REACT_APP_MIN_PRICE_FOR_SALE || "1";
export const INVENTORY_SIZE = process.env.REACT_APP_INVENTORY_SIZE || 50;

export const TxStatus = {
  WAIT_USER_CONFIRM_TX: 0,
  TX_EXECUTING: 1,
  TX_SUCCESS: 2,
  TX_FAILED: 3,
};
